<template>
  <div class="cp-wrap">
    <el-row :gutter="12">
      <!-- 左侧：分类树 -->
      <el-col :span="4">
        <div class="tree-panel">
          <div class="tree-title">产品分类</div>
          <el-tree
            ref="refTree"
            :props="treeProps"
            :load="loadNode"
            lazy
            node-key="id"
            highlight-current
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
          >
            <span slot-scope="{ data }" class="tree-node">
              <i :class="data.level >= 4 ? 'el-icon-document' : 'el-icon-folder'"></i>
              {{ data.name }}
            </span>
          </el-tree>
        </div>
      </el-col>

      <!-- 右侧：控制点列表 -->
      <el-col :span="20">
        <div class="list-panel">
          <div class="tabel-bar">
            <div class="tabel-bar-left path-bar">
              <el-breadcrumb v-if="pathNames.length" separator="/">
                <el-breadcrumb-item v-for="(n, i) in pathNames" :key="i">{{ n }}</el-breadcrumb-item>
              </el-breadcrumb>
              <span v-else class="path-empty">全部分类</span>
            </div>
            <div class="tabel-bar-right">
              <el-input
                placeholder="控制点名称"
                :size="$store.state.formSize"
                prefix-icon="el-icon-search"
                v-model="keywords"
                style="width: 180px; margin-right: 8px"
                @input="search"
              ></el-input>
              <el-button
                type="primary"
                :size="$store.state.buttonSize"
                :disabled="!isLeaf"
                :title="isLeaf ? '' : '请先点击左侧末级（第四级）分类'"
                @click="controlPointPopup()"
                >新增控制点</el-button
              >
              <RemoveButton
                type="info"
                :size="$store.state.buttonSize"
                @click="handleRemoveAll"
                :disabled="!selectionID.length"
                >批量删除</RemoveButton
              >
              <el-tooltip effect="dark" content="刷新列表" placement="bottom">
                <span class="el-icon-refresh icon-hover refresh-btn" @click="debounceRefresh"></span>
              </el-tooltip>
            </div>
          </div>

          <el-table
            ref="refTable"
            v-loading="loading"
            :data="tableData"

            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column prop="pointName" label="控制点名称" width="140"></el-table-column>
            <el-table-column prop="categoryName" label="所属分类" width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="threshold" label="限值" width="250" show-overflow-tooltip></el-table-column>
            <el-table-column label="是否可用" width="100" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status !== 0" type="success" size="small">启用</el-tag>
                <el-tag v-else type="info" size="small">停用</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="240" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="添加时间" width="170">
              <template slot-scope="scope">{{ scope.row.createTime | format }}</template>
            </el-table-column>
            <el-table-column prop="creatorName" label="添加人" width="110"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="170">
              <template slot-scope="scope">{{ scope.row.updateTime | format }}</template>
            </el-table-column>
            <el-table-column prop="updatorName" label="修改人" width="110"></el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status !== 0" type="text" @click="statusChange(scope.row)">停用</el-button>
                <el-button v-else type="text" @click="statusChange(scope.row)">启用</el-button>
                <el-button v-if="scope.row.status !== 0" type="text" @click="controlPointPopup(scope.row.id)">编辑</el-button>
                <el-button type="text" @click="controlPointDel(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="size"
            :total="total"
          ></pagination>
        </div>
      </el-col>
    </el-row>

    <!-- 控制点表单 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="controlPointFormVisible" center>
      <el-form
        :model="controlPointForm"
        :size="$store.state.formSize"
        :rules="controlPointFormRules"
        ref="refControlPointForm"
        label-width="140px"
      >
        <el-form-item label="控制点名称：" prop="pointName">
          <el-input v-model="controlPointForm.pointName" autocomplete="off"></el-input>
        </el-form-item>

        <!-- 分类固定展示为一行路径：新增取树选中的末级路径、编辑取数据回显，均不可修改 -->
        <el-form-item label="所属分类：">
          <el-input :value="categoryPathText" disabled></el-input>
        </el-form-item>

        <el-form-item label="限值：">
          <el-input v-model="controlPointForm.threshold" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="controlPointForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getControlPointList,
  delControlPointList,
  putControlPointAdd,
  postControlPointEdit,
  postControlPointStatus,
  deleteControlPointDel,
  getControlPointDetail
} from '@/api/controlpoint'
import { getCategoryList } from '@/api/category'

const createForm = () => ({
  pointName: '',
  categoryLevel1: '',
  categoryLevel2: '',
  categoryLevel3: '',
  categoryLevel4: '',
  categoryLevelName1: '',
  categoryLevelName2: '',
  categoryLevelName3: '',
  categoryLevelName4: '',
  threshold: '',
  remark: ''
})

export default {
  data() {
    return {
      treeProps: { label: 'name', isLeaf: 'isLeaf' },
      tableMaxHeight: 500,
      selectedPath: [], // 当前树选中链路 [{id,name,level}...]
      controlPointFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      currentID: null,
      isDisabled: false,
      loading: true,
      selectionID: [],
      tableData: [],
      controlPointForm: createForm(),
      controlPointFormRules: {
        pointName: [{ required: true, message: '请输入控制点名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑关键控制点' : '新增关键控制点'
    },
    pathNames() {
      return this.selectedPath.map(n => n.name)
    },
    // 弹窗内一行只读分类路径：新增取树选中路径，编辑取数据回显
    categoryPathText() {
      if (!this.currentID) {
        return this.pathNames.join(' / ')
      }
      return [
        this.controlPointForm.categoryLevelName1,
        this.controlPointForm.categoryLevelName2,
        this.controlPointForm.categoryLevelName3,
        this.controlPointForm.categoryLevelName4
      ]
        .filter(Boolean)
        .join(' / ')
    },
    // 是否选中了末级（第四级）分类
    isLeaf() {
      return this.selectedPath.length >= 4
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.controlPointSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    // 表格体最大高度：面板总高 - 顶部操作栏 - 分页栏，超出部分在表格内部滚动
    calcTableMaxHeight() {
      this.tableMaxHeight = window.innerHeight - 300
    },
    // ========== 左侧分类树 ==========
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.fetchChildren(0, 1, resolve)
      } else if (node.level >= 4) {
        resolve([])
      } else {
        this.fetchChildren(node.data.id, node.level + 1, resolve)
      }
    },
    fetchChildren(pid, level, resolve) {
      getCategoryList(pid)
        .then(res => {
          if (res.status === 1) {
            resolve((res.data || []).map(i => ({ id: i.id, name: i.name, level, isLeaf: level >= 4 })))
          } else {
            resolve([])
          }
        })
        .catch(() => resolve([]))
    },
    handleNodeClick(data, node) {
      const chain = []
      let n = node
      while (n && n.data && n.data.id !== undefined && n.data.id !== null) {
        chain.unshift(n.data)
        n = n.parent
      }
      this.selectedPath = chain
      this.page = 1
      this.getControlPointListData()
    },

    // ========== 右侧列表 ==========
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleSizeChange(val) {
      this.size = val
      this.page = 1
      this.getControlPointListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getControlPointListData()
    },
    search() {
      this.page = 1
      this.getControlPointListData()
    },
    refresh() {
      this.getControlPointListData()
      this.$message.success('数据刷新成功')
    },
    getControlPointListData() {
      this.loading = true
      const params = { page: this.page, size: this.size }
      if (this.keywords) {
        params.name = this.keywords
      }
      const levels = ['categoryLevel1', 'categoryLevel2', 'categoryLevel3', 'categoryLevel4']
      this.selectedPath.forEach((n, i) => {
        params[levels[i]] = n.id
      })
      getControlPointList(params).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
        // 数据渲染后强制重算表格布局，修正 fixed 列位置与滚动条状态
        this.$nextTick(() => {
          if (this.$refs.refTable) this.$refs.refTable.doLayout()
        })
      })
    },

    // ========== 启用/禁用 ==========
    statusChange(row) {
      const target = row.status === 1 ? 0 : 1
      const action = target === 1 ? '启用' : '停用'
      this.$confirm(`确定${action}该控制点吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          postControlPointStatus(row.id, target).then(res => {
            if (res.status === 1) {
              this.$message.success(`${action}成功`)
              row.status = target
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {})
    },

    // ========== 删除 ==========
    handleRemoveAll() {
      delControlPointList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getControlPointListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    controlPointDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteControlPointDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除控制点成功')
              this.getControlPointListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
    },

    // ========== 新增/编辑 ==========
    controlPointPopup(id) {
      const isAdd = !id
      if (isAdd && !this.isLeaf) {
        this.$message.warning('请先点击左侧末级（第四级）分类')
        return
      }
      this.controlPointFormVisible = true
      this.$set(this, 'controlPointForm', createForm())

      if (isAdd) {
        this.currentID = null
        // 新增：分类直接取当前树选中的末级路径
        const levels = ['categoryLevel1', 'categoryLevel2', 'categoryLevel3', 'categoryLevel4']
        this.selectedPath.forEach((n, i) => {
          this.controlPointForm[levels[i]] = n.id
          this.controlPointForm[levels[i] + 'Name'] = n.name
        })
      } else {
        this.isDisabled = true
        this.currentID = id
        getControlPointDetail(id).then(res => {
          if (res.status === 1) {
            this.controlPointForm.pointName = res.data.pointName
            this.controlPointForm.categoryLevel1 = res.data.categoryLevel1
            this.controlPointForm.categoryLevel2 = res.data.categoryLevel2
            this.controlPointForm.categoryLevel3 = res.data.categoryLevel3
            this.controlPointForm.categoryLevel4 = res.data.categoryLevel4
            this.controlPointForm.categoryLevelName1 = res.data.categoryLevelName1
            this.controlPointForm.categoryLevelName2 = res.data.categoryLevelName2
            this.controlPointForm.categoryLevelName3 = res.data.categoryLevelName3
            this.controlPointForm.categoryLevelName4 = res.data.categoryLevelName4
            this.controlPointForm.threshold = res.data.threshold
            this.controlPointForm.remark = res.data.remark
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    controlPointSubmit() {
      this.$refs.refControlPointForm.validate(valid => {
        if (!valid) return false
        const changeControlPoint = this.currentID ? postControlPointEdit : putControlPointAdd
        changeControlPoint({
          pointName: this.controlPointForm.pointName,
          categoryLevel1: this.controlPointForm.categoryLevel1,
          categoryLevel2: this.controlPointForm.categoryLevel2,
          categoryLevel3: this.controlPointForm.categoryLevel3,
          categoryLevel4: this.controlPointForm.categoryLevel4,
          threshold: this.controlPointForm.threshold,
          remark: this.controlPointForm.remark,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('编辑关键控制点成功')
              : this.$message.success('新增关键控制点成功')
            this.controlPointFormVisible = false
            this.getControlPointListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    hanleResetFormVals() {
      this.controlPointFormVisible = false
      this.$set(this, 'controlPointForm', createForm())
      this.$refs.refControlPointForm.clearValidate()
    }
  },
  mounted() {
    this.getControlPointListData()
    this.calcTableMaxHeight()
    window.addEventListener('resize', this.calcTableMaxHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableMaxHeight)
  },
  filters: {
    format(value) {
      return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.cp-wrap {
  .tree-panel {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    // 视口内固定高度，树区域自身滚动（避免整页滚动）
    height: calc(100vh - 180px);
    min-height: 500px;
    padding: 10px;
    display: flex;
    flex-direction: column;

    .tree-title {
      font-weight: bold;
      padding: 4px 6px 10px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 8px;
      flex: none;
    }

    ::v-deep .el-tree {
      flex: 1;
      overflow-y: auto;
    }

    .tree-node i {
      margin-right: 4px;
      color: #409eff;
    }
  }

  .list-panel {
    // 与左侧树等高，内容超出时表格体内部滚动，页面不出整体滚动条
    height: calc(100vh - 180px);
    min-height: 500px;
    display: flex;
    flex-direction: column;

    // 强制表格体可横向滚动：列总宽超出面板宽度时必出横向滚动条
    //（不依赖 el-table 内部 scrollX 判定，其读取 clientWidth 时机异常时会把超出列直接裁剪掉）
    ::v-deep .el-table__body-wrapper {
      overflow-x: auto !important;
    }

    .path-bar {
      display: flex;
      align-items: center;
      min-height: 28px;

      .path-empty {
        color: #909399;
        font-size: 13px;
      }
    }
  }

  .refresh-btn {
    margin-left: 8px;
    cursor: pointer;
  }
}
</style>
